import React from 'react';
import { PageHeader } from 'antd';
import cn from 'classnames';

function PageTitle({ className, title, extra }) {
  return (
    <PageHeader
      className={cn('page-title', className)}
      title={<div className="page-title__title">{title}</div>}
      extra={extra}
    />
  );
}

export default PageTitle;
